import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from '../model/user.model';
import { Product } from '../model/product.model';
import { Unit } from '../model/unit.model';
import { Feature } from '../model/feature.model';
import { Observable, Subject, throwError } from 'rxjs';
import { Catagory } from '../model/catagory.model';
import { Subcatagory } from '../model/subcatagory.model';
import { Manufacture } from '../model/manufacture.model';
import { Group } from '../model/group.model';
import { Ledger } from '../model/ledger.model';
import { Branch } from '../model/branch.model';
import { Login } from '../model/login.model';
import { Logintoken } from '../model/logintoken.model';
import { Godown } from '../model/godown.model';
import { Stockedit } from '../model/stockedit.model';
import { Batch } from '../model/batch.model';
import { Repcatagory } from '../model/report/repcatagory.model';
import { Repprddet } from '../model/report/repprddet.model';
import { Sales } from '../model/report/sales.model';

import { Supplier } from '../model/ledger/supplier.model';
import { Purchase } from '../model/purchase';
import { Reppurchsum } from '../model/report/reppurchsum.model';
import { ProductUnit } from '../model/product-unit';
import { Reppurchdet } from '../model/report/reppurchdet.model';

import { Vanline } from '../model/vanline.model';
import { Van } from '../model/van/van.model';
import { environment } from '../../environments/environment';
import { Employee } from '../model/employee.model';
import { catchError } from 'rxjs/operators';
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  users: User[];
  products: Product[];
  S3_SERVER = "https://fujishkaerp-files-replica.s3.ap-south-1.amazonaws.com";
  PHP_API_LOC_SERVER1 = "http://bquickerp.com/backend";
  PHP_API_LOC_SERVER2 = "http://127.0.0.1:8000";
  PHP_API_SERVER = ((environment.php_api_server != '') ? environment.php_api_server : `${window.location.origin}/backend`);
  // PHP_API_SERVER = this.PHP_API_LOC_SERVER1;
  token = localStorage.getItem("auth_token");
  usr_type = localStorage.getItem("usr_type");
  routeftn: any;
  // notificationChange = <any> 0;
  // public notificationChange: Observable<number>;
  public notificationChange: Subject<number> = new Subject<number>();
  public cur_lang: Subject<any> = new Subject<any>();
  public salesordernotificationChange: Subject<number> = new Subject<number>();
  public transactionEditReq: Subject<number> = new Subject<number>();
  public hrEmployeeAdvance: Subject<number> = new Subject<number>();
  public salesduenotificationChange: Subject<number> = new Subject<number>();
  public purchaseduenotificationChange: Subject<number> = new Subject<number>();
  public notificationBatchChange: Subject<number> = new Subject<number>();
  public pendingEinvoiceNotificationChange: Subject<any> = new Subject<any>();
  public invoiceRequestChange: Subject<any> = new Subject<any>();
  public discountInvoiceRequest: Subject<any> = new Subject<any>();
  public salaryRequestNotification: Subject<number> = new Subject<number>();
  
  constructor(private httpClient: HttpClient, public router: Router) { }

  updateLanguage() {
      this.cur_lang.next(sessionStorage.getItem("baseLang"));
  }
  
  updatePDCNotification() {
    this.getPDCcount({ cheq_issue_date: this.formatDate(new Date()) }).subscribe((res) => {
      this.notificationChange.next(res['data']);
    });

  }
  updateSalesOrderNotification() {
    this.getSalesOrdercount({ today_date: this.formatDate(new Date()) }).subscribe((res) => {
     this.salesordernotificationChange.next(res['data']);
    });

  }

   transactionEditReqNotification() {
    this.getTransactionEditReqcount({ today_date: this.formatDate(new Date()) }).subscribe((res) => {
     this.transactionEditReq.next(res['data']);
    });

  }

  hrEmployeeAdvanceNotification() {
    this.AdvanceCount().subscribe((res: any) => {
      this.hrEmployeeAdvance.next(res.data);
    });
  }

    updateSalesDueNotification() {
    this.getSalesDuecount({ today_date: this.formatDate(new Date()) }).subscribe((res) => {
      this.salesduenotificationChange.next(res['data']);
    });

  }
   updatePurchaseDueNotification() {
    this.getPurchaseDuecount({ today_date: this.formatDate(new Date()) }).subscribe((res) => {
      this.purchaseduenotificationChange.next(res['data']);
    });

  }

  updateEinvoiceNotificationChange() {
    this.getEinvoicecount({ today_date: this.formatDate(new Date()) }).subscribe((res) => {
      this.pendingEinvoiceNotificationChange.next(res['data']);
    });

  }

  updatebatchExNotification() {
    this.batchExCount().subscribe((res) => {
      this.notificationBatchChange.next(res['data']);
    });

  }
   updateInvoiceRequest(data) {
    this.getInvoiceRequest(data).subscribe((res) => {
      this.invoiceRequestChange.next(res);
    });

  }

   getDiscountInvoiceRequest(data) {
    this.getDiscountInvoiceRequests(data).subscribe((res) => {
      this.discountInvoiceRequest.next(res);
    });
  }

  updateSalaryRequestNotification() {
    this.getSalaryRequestCount().subscribe((res) => {
      this.salaryRequestNotification.next(res['data']);
    });
  }
  

  readUsers(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.PHP_API_SERVER + '/api/users', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createUser(user: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/usr_register', user, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateUser(user: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/edit_user_details', user, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createProduct(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/add_product', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  translateProductName(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/translate_product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createUnit(unit: Unit): Observable<Unit> {
    return this.httpClient.post<Unit>(this.PHP_API_SERVER + '/api/add_unit', unit, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateUnit(unit: Unit): Observable<Unit> {
    return this.httpClient.post<Unit>(this.PHP_API_SERVER + '/api/edit_unit', unit, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readBase(id: number): Observable<Unit[]> {
    return this.httpClient.get<Unit[]>(this.PHP_API_SERVER + '/api/get_base_units/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readUnit(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/get_units', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchunits(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_units',res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readFeat(): Observable<Feature[]> {
    return this.httpClient.get<Feature[]>(this.PHP_API_SERVER + '/api/get_features', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readBaseunit(unit: Unit): Observable<Unit> {
    return this.httpClient.post<Unit>(this.PHP_API_SERVER + '/api/get_base_unit_details', unit, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createFeat(feat: Feature): Observable<Feature> {
    return this.httpClient.post<Feature>(this.PHP_API_SERVER + '/api/add_feature', feat, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateFeat(feat: Feature): Observable<Feature> {
    return this.httpClient.post<Feature>(this.PHP_API_SERVER + '/api/edit_feature', feat, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  createCat(catagory: Catagory): Observable<Catagory> {
    return this.httpClient.post<Catagory>(this.PHP_API_SERVER + '/api/add_category', catagory, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createExcsCat(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/add_excs_category', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateExcsCat(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/update_excs_category', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllExcsTaxCategory(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_excs_category', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }




  readCat(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/get_categories', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchCats(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_categories',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateCat(catagory: Catagory): Observable<Catagory> {
    return this.httpClient.post<Catagory>(this.PHP_API_SERVER + '/api/edit_category', catagory, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createSubCat(res: Subcatagory): Observable<Subcatagory> {
    return this.httpClient.post<Subcatagory>(this.PHP_API_SERVER + '/api/add_subcategory', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSubCatbyId(id: number): Observable<Subcatagory[]> {

    return this.httpClient.get<Subcatagory[]>(this.PHP_API_SERVER + '/api/get_subcategories/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readDerbyId(id: number): Observable<Unit[]> {
    return this.httpClient.get<Unit[]>(this.PHP_API_SERVER + '/api/get_drvd_units/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  updateSubCat(res: Subcatagory): Observable<Subcatagory> {
    return this.httpClient.post<Subcatagory>(this.PHP_API_SERVER + '/api/edit_subcategory', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllSubCatbyId(id: any): Observable<Subcatagory[]> {
    return this.httpClient.get<Subcatagory[]>(this.PHP_API_SERVER + '/api/get_allsubcategories/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSubCatAll(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/get_subcat_all', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createManf(res: Manufacture): Observable<Manufacture> {
    return this.httpClient.post<Manufacture>(this.PHP_API_SERVER + '/api/add_manufacturer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readManfs(): Observable<Manufacture[]> {
    return this.httpClient.get<Manufacture[]>(this.PHP_API_SERVER + '/api/get_manufacturers', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateManf(res: Manufacture): Observable<Manufacture> {
    return this.httpClient.post<Manufacture>(this.PHP_API_SERVER + '/api/edit_manufacturer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readProd(): Observable<Product[]> {
    return this.httpClient.get<Product[]>(this.PHP_API_SERVER + '/api/get_products', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateProd(prod: any): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/edit_product', prod, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteProduct(prod: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/delete_product', prod, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteAddBarcode(prod): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/delete_add_barcode', prod, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  setStockAlertBranchWise(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/product/edit_stock_alert_branch_wise', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addStockAlertBranchWise(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/product/add_stock_alert_branch_wise', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdById(id: number): Observable<Product[]> {
    return this.httpClient.get<Product[]>(this.PHP_API_SERVER + '/api/get_prod_detail/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdUnits(res: FormData): Observable<ProductUnit> {
    return this.httpClient.post<ProductUnit>(this.PHP_API_SERVER + '/api/get_prod_units', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAddonProdUnits(res: FormData): Observable<ProductUnit> {
    return this.httpClient.post<ProductUnit>(this.PHP_API_SERVER + '/api/get_addon_prod_unit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateProdUnit(prod: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/edit_prod_units', prod, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateProdFeat(prod: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/edit_prod_features', prod, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdByName(res: FormData): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/get_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdByName1(res: FormData): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/get_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getProdByBarcode(res: FormData): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/get_search_barcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getProdByCode(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/prd_search_by_code?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  selectProdDetailBySystemBarode(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/prd_search_by_system_brcd?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getProdByEanBarcode(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/prd_search_by_ean_brcd?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getGroupbyName(res: FormData): Observable<Group> {
    return this.httpClient.post<Group>(this.PHP_API_SERVER + '/api/get_all_ledgroup', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLedByName(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/search_ledger', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getallLedgers(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/supplier/get_all_ledgers', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLedDetailsByName(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/search_ledger_detail', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getUserByName(res: FormData): Observable<User> {
    return this.httpClient.post<User>(this.PHP_API_SERVER + '/api/search_users', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getProductionStaffByName(res: FormData): Observable<User> {
    return this.httpClient.post<User>(this.PHP_API_SERVER + '/api/search_production_staffs', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getManfbyName(res: FormData): Observable<Manufacture> {
    return this.httpClient.post<Manufacture>(this.PHP_API_SERVER + '/api/search_manufacturers', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCatbyName(res: FormData): Observable<Catagory> {
    return this.httpClient.post<Catagory>(this.PHP_API_SERVER + '/api/search_categories', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSubCatbyName(res: FormData): Observable<Catagory> {
    return this.httpClient.post<Catagory>(this.PHP_API_SERVER + '/api/search_subcategories', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBatchbyName(res: FormData): Observable<Batch> {
    return this.httpClient.post<Batch>(this.PHP_API_SERVER + '/api/stock_search/batch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBranchByName(res: FormData): Observable<Branch> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/search_branch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBatchByName(res: FormData): Observable<Branch> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/stock_search/all_batch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCountry(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/search_country', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLength(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_length', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
   getLoyaltyCustomer(res: FormData,pageno): Observable<Branch> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/loyalty_customer?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
    getLoyaltyCustomerDetails(res: any): Observable<Branch> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/loyalty_customer_detailes', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBranchstockAlert(res: FormData): Observable<Unit> {
    return this.httpClient.post<Unit>(this.PHP_API_SERVER + '/api/product/get_branch_stock_alert', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getUnitByName(res: FormData): Observable<Unit> {
    return this.httpClient.post<Unit>(this.PHP_API_SERVER + '/api/search_units', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getGodownByName(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/search_godown', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getRentalGd(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godown_stock/get_rental_godown', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getUnit(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/stock/get_unit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getGodownList(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godowns_list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSubcatByName(res: FormData): Observable<Subcatagory> {
    return this.httpClient.post<Subcatagory>(this.PHP_API_SERVER + '/api/search_subcat', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readPriGrp(): Observable<Group[]> {
    return this.httpClient.get<Group[]>(this.PHP_API_SERVER + '/api/get_primary_ledgroup', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getEditledGrp(res: FormData): Observable<Subcatagory> {
    return this.httpClient.post<Subcatagory>(this.PHP_API_SERVER + '/api/get_edit_ledgroup', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  readAllGrp(): Observable<Group[]> {
    return this.httpClient.get<Group[]>(this.PHP_API_SERVER + '/api/get_ledgroup', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createGroup(res: Group): Observable<Group> {
    return this.httpClient.post<Group>(this.PHP_API_SERVER + '/api/add_ledgroup', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateGroup(res: Group): Observable<Group> {
    return this.httpClient.post<Group>(this.PHP_API_SERVER + '/api/edit_ledgroup', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createLedger(res: Ledger): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/add_ledger', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createLedgerPopup(res: Ledger): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/add_ledger_popup', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateLedger(res: Ledger): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/edit_ledger', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  deleteLedger(res: Ledger): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/delete_ledger', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  createBranch(res: Branch): Observable<Branch> {
    res.branch_open_date = this.formatDate(res.branch_open_date);
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/add_branch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateBranch(res): Observable<Branch> {
    res.branch_open_date = this.formatDate(res.branch_open_date);
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/edit_branch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  zatcaOnboard(res): Observable<any> {
    res.branch_open_date = this.formatDate(res.branch_open_date);
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/zatca_onboard', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  zatcaRenewToken(res): Observable<any> {
    res.branch_open_date = this.formatDate(res.branch_open_date);
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/zatca_renew_token', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  disableBranch(res): Observable<Branch> {
    res.branch_open_date = this.formatDate(res.branch_open_date);
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/branch_disable', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  login(res: Login): Observable<Login> {
    return this.httpClient.post<Login>(this.PHP_API_SERVER + '/api/login', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  supportLogin(res: FormData): Observable<Branch> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/support/support_login', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   supportActions(res: FormData): Observable<Branch> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/support/support_actions', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSupportActions(res: FormData): Observable<Branch> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/support/get_support_actions', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  supportAdminLogin(res: FormData): Observable<Branch> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/support/support_admin_login', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getInvDet(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/get_inv_det', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  LogOut(): Observable<Logintoken[]> {
    return this.httpClient.get<Logintoken[]>(this.PHP_API_SERVER + '/api/logout', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  readUsrTypes(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.PHP_API_SERVER + '/api/get_user_types', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readsubUsrTypes(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.PHP_API_SERVER + '/api/get_sub_users', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readAllBranch(): Observable<Branch[]> {
    return this.httpClient.get<Branch[]>(this.PHP_API_SERVER + '/api/get_branches', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readAllActiveBranch(): Observable<Branch[]> {
    return this.httpClient.get<Branch[]>(this.PHP_API_SERVER + '/api/get_all_active_branches', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createGodown(res: Godown): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godown/add', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readBaseUnits(): Observable<Unit[]> {
    return this.httpClient.get<Unit[]>(this.PHP_API_SERVER + '/api/get_base_units', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllBranches(): Observable<Branch[]> {
    return this.httpClient.get<Branch[]>(this.PHP_API_SERVER + '/api/get_branches', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getAllBranchesforTransfer(): Observable<Branch[]> {
    return this.httpClient.get<Branch[]>(this.PHP_API_SERVER + '/api/get_branches_data', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllBranchesforStockAlert(res): Observable<any> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/get_branches_data_for_stockAlert', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateGodown(res: Godown): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godown/edit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllPrdLoactions(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/listAll_prd_location',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getStockbyName(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getExcludeBranchesforStock(res): Observable<any> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/get_exclude_branches_for_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getOpStockbyName(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock_search/product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateStock(res): Observable<Stockedit> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/update', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateStockMultiBranch(res): Observable<Stockedit> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/update_multi_br', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addOpStock(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/open_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readCatReport(res: FormData): Observable<Repcatagory> {
    return this.httpClient.post<Repcatagory>(this.PHP_API_SERVER + '/api/product_report/category', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  transferGodown(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/godown_transfer/add', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPrdRepkbyName(res: FormData): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/product_report/details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  prodSum(res: Repprddet): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/product_report/summary', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  prodSumPage(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/product_report/summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  prodSumWithstock(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/product_report/stock_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  ManSumPage(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/product_report/manufacture_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockSumPage(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/stock_report/summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  supplierRep(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/supplier_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getOutstandingPayable(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/purchase_report/outstanding_payable_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  importPurchaseOrder(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/purchase_report/import_purchaseorder?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createProductBase(product: any): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/new_product', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   importOfferProducts(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/offer/import_products?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createProductUnit(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/add_derived', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  editProductUnit(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/edit_derived', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createProductFeat(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/add_features', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  createProductStock(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/add_stock_rates', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  OpStokcSum(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/stock_report/opening_stock_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockRepPeriod(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/stock_report/by_period?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  stockRepPeriodOld(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/stock_report/by_period_old?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  stockAgingReports(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/stock_report/stock_aging_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createSupplier(res: Supplier): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/add_supplier', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateSupplier(res: Supplier): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/edit_supplier', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchSupplier(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/search_supplier', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateBothBalance(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/update_both_balance', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchSupplierCode(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/quick_purchase/search_supplier_code', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSupplierData(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/quick_purchase/get_supplier', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  getAllLedByName(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/quick_purchase/search_ledger', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchPurchases(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/search_purchases', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getRebatePurchase(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/get_rebate_purchase', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  // getPurchasebyName(res: FormData): Observable<Stockedit> {
  //   return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock_search/purchase', res, {
  //     headers: new HttpHeaders({
  //       'Access-Control-Allow-Origin': '*',
  //       Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
  //       cmptoken: localStorage.getItem('cmptoken')
  //     })
  //   }).pipe(catchError((error) => this.checkServerError(error)));
  // }

  addPurchase(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/purchase', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addQuickPurchase(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/quick_purchase/add_quick_purchase', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addGoodsReceipt(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/goods_receipts/add_goods_receipt', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  saveTempPurchase(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/purchase/temp_purchase', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  saveTempPurchaseReutn(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/purchase/temp_purchase_return', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  saveTmpExternalStockTransfer(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/externalstocktransfer/temp_transfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getsaveTempPurchase(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/purchase/list_tpurchases', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getsaveTempPurchaseReturn(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/purchase/list_tpurchases_return', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getsaveTempExtStock(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/externalstocktransfer/list_tstocktransfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTempPurchase(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/open_temp_purchase', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getTempPurchaseReturn(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/open_temp_purchase_return', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTempExStockDraft(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/externalstocktransfer/open_temp_ex_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  removeFromDraft(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/removeDraft', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  VanClearToken(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/van/clear_token', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  removeFromDraftReturn(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/removeDraftpurchreturn', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  removeFromExStockDraft(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/externalstocktransfer/remove_temp_transfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getpurchaseDetails(res: FormData): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/purchase_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  interbranchimportproducts(res: FormData): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/branchtransfer/import_products', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  receiptImport(res: FormData): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/receipt/import', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  paymentImport(res: FormData): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/payment/import', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPurchaseData(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/purchase_data_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getimportpurchaseDetails(res: FormData): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/purchase_import_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getGoodsReceiptDetails(res: FormData): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/goods_receipts/goods_rec_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  
  getSubTotal(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/purchase/item_sum', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidPurchase(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/purchase_void', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getOpStockbyNameRem(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/list_opening_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getUnAsignedStock(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/list_unasigned_van_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  assignStockToVan(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/assign_stock_to_van', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  remOpStock(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/opening_stock_remoove', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  manfDetailReport(res: FormData): Observable<Manufacture> {
    return this.httpClient.post<Manufacture>(this.PHP_API_SERVER + '/api/product_report/manufacture_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPurchase(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/get_purch_num', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getGoodsRecNo(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/goods_receipts/get_goods_rec_num', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseSummary(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/purchase_report/summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  purchaseDeatils(res: FormData, pageno: number): Observable<Reppurchdet> {
    return this.httpClient.post<Reppurchdet>(this.PHP_API_SERVER + '/api/purchase_preview' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseSummaryReport(res: FormData): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/purchase_report/summary', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseReturnSummary(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/purchase_report/return_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseInvDueummary(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/purch_inv_due_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  goodsRecieptReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/goods_reciept_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  suppAgingRpt(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/supp_aging?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  custMovmentRpt(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/cust_movmnt?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseReturnProductSummary(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/purchase_report/return_product?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  ListVanline(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/vanline/list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addNewVanLine(Vanline: Vanline): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/vanline/add', Vanline, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateVanLine(Vanline: Vanline): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/vanline/update', Vanline, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  changeStatus(Vanline: Vanline): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/vanline/activate', { 'vanline_id': Vanline }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  changevanStatus(Vanline: Vanline): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/van/activate', { 'van_id': Vanline }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  changeappLoginStatus(Vanline: Vanline): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/van/activate_user_app_login', { 'id': Vanline }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  ListVan(res: FormData, pageno: number): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van/list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  ListVanUsers(res: FormData, pageno: number): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van/list_van_users?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  userAppLoginDetails(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van/get_user_app_login_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  ListVanTarget(res: FormData, pageno: number): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van/van_targetlist?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addNewVan(Van: Van): Observable<Van> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/van/add', Van, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateVan(Van: Van): Observable<Van> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/van/update', Van, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  changeVanStatus(Vanid: Van): Observable<Van> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/van/activate', { 'van_id': Vanid }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  addVanTarget(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van/add_van_target', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanTarget(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van/get_van_target', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanlinesName(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/vanline/search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  godownSumPage(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/godown_report/summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  godownProduct(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/godown_report/product?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  godownTrans(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/godown_report/transaction?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  godownSerialNoWiseTraking(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/godown_report/godown_serial_no_wise_traking?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  godownTransDetailed(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/godown_report/detailed?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  purchaseInvoiceRep(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/purchase_based?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  prodInvoiceRep(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/product_based?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  getNxtVanTranId(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/getNxtVanTranId', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getNxtVanRetTranId(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/getNxtVanRetTranId', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchVans(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van/search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchReceiptProducts(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/externalstockreceipt/search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchReceiptProductsUpdted(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/externalstockreceipt/ext_reciept_prd_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getRecieptingProdDetails(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/externalstockreceipt/ext_reciept_prd_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchVanProducts(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van_transfer/search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanTransfer(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van_transfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanTransferLog(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/interstocktrnsfer/van_transfer_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  removeFromVanTransferLog(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/interstocktrnsfer/remove_van_transfer_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanTransferLog(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/interstocktrnsfer/get_van_transfer_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanTransferLogs(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/interstocktrnsfer/list_van_transfer_logs', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getVantransferData(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/interstocktrnsfer/get_van_transfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  allReturnedItems  (res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/interstocktrnsfer/get_all_returned_items', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importVanTransferExcel(formData: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/interstocktrnsfer/excel_import', formData, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanTransferEdit(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_transfer_edit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readVanTransfers(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/van_transfer/report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  readVanTransfersItemReport(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van_transfer/item_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  vanSalereport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_sale_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  vanuserSalereport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_reports/van_user_sale_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  readVanTransfersInvoiceReport(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van_transfer/invoice_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createStaff(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/staff/add', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listAllStaff(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/staff/list_all', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  listAllActiveStaff(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/staff/list_all_active', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  changeStaffStatus(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/staff/change_status', { 'st_id': id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  vanDbForceClose(info): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van/force_db_close', { 'van_id': info.van_id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  desktopDbForceClose(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/force_desk_db_close', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  closeCurrentDb(info): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/backup/close_current_db', info, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createNewDbByClient(info): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/backup/create_new_db_by_client', info, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  financialClosing(info): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/backup/financial_close_by_client', info, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  checkAllBranchDBClosed(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/backup/check_all_branch_db_closed', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  ListAllVan(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van/list_all', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  ListAllVanByBranch(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van/list_all_by_branch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanProducts(res: FormData, vanid: number): Observable<Van> {
    return this.httpClient.get<Van>(this.PHP_API_SERVER + '/api/van/list_products?vanid=' + vanid, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

    getVanProductsNew(res: FormData, vanid: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van/list_van_products_new?vanid=' + vanid, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanAllProducts(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van/vanAll_products', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  readVanTransfersReporteByDate(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van_transfer/by_period?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  vanTransferReturn(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/transfer_return', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanTransferReturnUpdate(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/transfer_return_update', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  ListAllVanReturns(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/van_transfer_return/report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updatePurchaseNote(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/update_purch_note', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

 // do not use this api other than purchase bcz add some exeption in this (by ajmal)
  getPurchasebyBcode(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock_search/purchasebcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProductGlobalSearch(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock_search/productGlobalSearch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getTranDetails(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/tran_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getTranReturnDetails(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/tran_return_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  voidVanTransfer(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/vantran_void', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  voidVanTransferReturn(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/vantranreturn_void', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdByNamePrret(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/search_stock_products', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseReturn(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase/return', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPurchaseRetbyBcode(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/search_stock_barcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPurchaseReturn(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/get_purch_ret_num', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getpurchaseRetDetails(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/list_purchase_return', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidPurchaseRet(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/void_purchase_return', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listPurchaseReturns(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/list_all_purchase_returns?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  productionPreview(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/production/preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustomers(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/list?page=' + curPage + '&per_page=' + perPage, {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getBackups(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/backup/list', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createDatabaseBackup(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/backup/create', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  filterCustomer(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/filter_cust?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  filterLedger(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/filter_ledger?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanCalendarRpt(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_calendar?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllVanlines(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/vanline/list_all', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllPriceGroup(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/list_all', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createCustomer(data): Observable<any> {
    data.glblblue_passport_dob = this.formatDate(data.glblblue_passport_dob);
    data.glblblue_passport_exp_date = this.formatDate(data.glblblue_passport_exp_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createCostCenter(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/costcenter/addcostcenter', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateCostCenter(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/costcenter/updatecostcenter', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createCostCenterSub(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/costcenter/addcostcenterSub', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updatedCostCenterSub(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/costcenter/updatecostcenterSub', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getCostCenter(data): Observable<any> {
      return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/costcenter/list', data, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createCustOrSup(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createSup(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/add_sup', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateCustomer(data): Observable<any> {
    data.glblblue_passport_dob = this.formatDate(data.glblblue_passport_dob);
    data.glblblue_passport_exp_date = this.formatDate(data.glblblue_passport_exp_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getCustomer(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/item', { cust_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteCustomerDoc(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/delete_document', { cust_doc_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  deleteSpecialPrice(sur_id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/delete_special_price', { sur_id: sur_id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  deleteDBBackUp(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/backup/deletedbbkp', { bkp_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getCustomerDetails(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/get_customer_details', { cust_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  quickCustomerSearch(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/quick_customer_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  CustomerCustcodeSearch(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/customer_custcode_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  VatNumberSearch(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/customer_vat_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  ProductcodeSearch(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/product_code_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchCustomer(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustDetails(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/get_cust_detials', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchBarcode(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/search_barcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchAllBarcode(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/search_all_barcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchBarcodeAndProduct(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/search_barcode_and_product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  

  searchByPrdode(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/search_by_prdcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchInvNumber(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/search_inv', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  geProdctnId(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/next_production_id', { cust_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getSalesOrderQty(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales_orders/get_sales_order_prd_qty', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPrdQty(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales_orders/get_prd_qty', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  gebranchTranId(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/next_tran_id', { cust_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  gereqId(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_transfer_request/next_req_id', { cust_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }
  voidProduction(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/production/void', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  // do not use this api other than purchase bcz add some exeption in this (by ajmal)

  getPurchasebyUean(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock_search/purchaseuean', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseAndreturn(res: FormData, pageno: number): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/purchase_report/purchase_return_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  expSumm(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/stock_expiry_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getUsersList(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/users_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBranchList(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/branch_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllBranchList(): Observable<any> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/get_branch_list', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  changeUserStatus(Vanline: Vanline): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/user/activate', { 'user_id': Vanline }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   changePromoStatus(promoId: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/activate', { 'promo_id': promoId }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  changePrdctStatus(prdId:any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/prd_status', {'prd_id': prdId}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  changeAddonPrdctStatus(AddonId:any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/addon_prd_status', {'prd_id': AddonId}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createUnitList(product,addBarcode = []): Observable<any> {
    product.addBarcodes = JSON.stringify(addBarcode);
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/add_list_product', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createFeatList(product: Product): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/add_list_feature', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanProductsReturn(res: FormData, vanid: number): Observable<Van> {
    return this.httpClient.get<Van>(this.PHP_API_SERVER + '/api/van/list_return_product', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesSummary(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  salesInvoiceSummary(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/invoice_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  delveryChallanRpt(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/delivery_challan_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesOrderRpt(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/sales_order_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesQtnSummaryReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/sales_qtn_summary_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  creditNoteRpt(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/cr_note_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  debitNoteRpt(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/dr_note_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseOrderRpt(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/purchase_order_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  rebateReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/purchase_rebate_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  cashCounter(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/cash_counter', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getCounterSetting(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_counter_setting', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesandRetunSummary(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/all_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  InvoicedueSummary(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/due_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  SalesAgentReport(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/sales_agent_wise_report', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  SalesAgentWiseReport(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/sales_agent_wise_report2', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  SalesAgentInvoiceDetails(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/sales_agent_invoice_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  InvoicedueSummary2(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/aging?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustomerBalanceDetail(res: FormData): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/customer_balance', res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanAgingReports(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/van_report/van_aging_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanSelfieAttReports(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/van_report/van_selfi_attendance_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesProductInvoice(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/product_invoice?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesRatioRep(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/sales_ratio_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  freeOfCostReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/free-of-cost-report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesrepbyserialno(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/salesrep_serial?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   purchaserepbyserialno(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/purchase_report/purchaserep_serial?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  fuelDailyTransactions(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/stock_report/fuel_daily_transactions?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  fuelProfitAndLoss(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/stock_report/fuel_profit_loss?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  BatchStock(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/batch_report/batch_wise_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  batchStockRepPeriod(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/batch_report/by_period?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanBatchStockRep(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/van_batch_report/batch_wise_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

 

  delChallanItemWise(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/delivery_challan_rpt_itemwise?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesProductReport(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/product_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  salesCustomerReport(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/customer_product_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  returnedProductReport(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/return_product_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchVanProductsReturn(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van/list_return_product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBranchData(res: FormData): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/branch_data', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  yearsAfterBranchOpeningDate(res: FormData): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/years_after_branch_opening_date', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  recieptPaymentCount(res: FormData): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/branch_recipt_paymnt_count', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  mainBranchCheck(res: FormData): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/main_branch_check', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  mainBranch(res: FormData): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/main_branch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getMainBranch(res: FormData): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/get_main_branch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getCompanyData(res: FormData): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/company_data', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  updateCompany(res): Observable<Branch> {
    res.cmp_finyear_start = this.formatDate(res.cmp_finyear_start);
    res.cmp_finyear_end = this.formatDate(res.cmp_finyear_end);
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/update_company', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllAccount(res: FormData = new FormData()) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_cashinhand_bank_ledger', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllBankAccount(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/bank_ledgers', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getAllNonAccountLedgres(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_non_acc_ledger', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllNonAccountLedgers(res: FormData = new FormData()): Observable<any> {
    return this.httpClient.post<any>(
      this.PHP_API_SERVER + '/api/get_non_acc_ledgers',
      res,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustomerLedgres(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_customer_ledger', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

 

  searchLedgerByAccGroup(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_acc_ledger_by_grp', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')

      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listLedger(pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/list_leadgers?page=' + pageno, {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listSupplier(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/show_suppliers', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createReceipt(data): Observable<any> {
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createCurrency(data): Observable<any> {
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/currency/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createServiceType(data): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/service_type/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createFavorite(data): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/favorite/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getMeasurementCategory(res: FormData): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/measurements_category/get_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getAllMeasurementCategory(res: FormData): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/measurements_category/get_all_category', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createMeasurement(data): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   createMeasurementCategory(data): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements_category/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllFavorites(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/favorite/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllMeasurements(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllRepackig(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/repacking/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllMeasurementsCat(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements_category/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getFavorite(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/favorite/get_item', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getMeasurement(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements/get_item', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getRepacking(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/repacking/get_repacking', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getMeasurementCat(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements_category/get_item', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateFavorite(data): Observable<any> {
    
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/favorite/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   updateMeasurement(data): Observable<any> {
    
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   updateRepacking(data): Observable<any> {
    
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/repacking/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

    updateMeasurementCategory(data): Observable<any> {
    
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements_category/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteFavorite(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/favorite/void', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteMeasurement(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements/void', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteRepacking(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/repacking/void', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteMeasurementCat(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/measurements_category/void', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  viewFavoriteProd(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/favorite/view_fav_products', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  deleteFavoriteProd(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/favorite/delete_fav_products', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getFavoritebyName(res: FormData): Observable<Catagory> {
    return this.httpClient.post<Catagory>(this.PHP_API_SERVER + '/api/favorite/search_fav', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getFavProdDetails(res: FormData): Observable<Catagory> {
    return this.httpClient.post<Catagory>(this.PHP_API_SERVER + '/api/favorite/get_fav_prod_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addFavProducts(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/favorite/add_fav_prod', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchFavProducts(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/favorite/search_fav_prod', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createFreightType(data): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/freight_type/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createPalletManagement(data): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/pallets_mangements/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updatePalletManagement(data): Observable<any> {
    
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/pallets_mangements/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPallet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/pallets_mangements/get_item', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deletePallet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/pallets_mangements/void', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getNextPalletId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/pallets_mangements/next-id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  itemMovementSummaryReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/item_movement_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createPDC(res:FormData): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/add', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  submitPDC(res:any): Observable<any> {
    res.cheq_issue_date = this.formatDate(res.cheq_issue_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/submit_cheque', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  bouncePDC(res:any): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/bounced_cheque', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  cancelPDC(res:any): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/cancelled_cheque', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createInterReceipt(data): Observable<any> {
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/inter_add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateReceipt(data): Observable<any> {
    // data = this.updateDateEntry(data);
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateCurrency(data): Observable<any> {
    // data = this.updateDateEntry(data);
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/currency/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateServiceType(data): Observable<any> {
    
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/service_type/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateFreightType(data): Observable<any> {
    
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/freight_type/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updatePDC(data:FormData): Observable<any> {
    // // data = this.updateDateEntry(data);
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getQtybyName(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/search_rates', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  rateEditLog(res: FormData,pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/rate_edit_history?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  transactionVoidLog(res: FormData, pageno: number = 1): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/transaction_void_log?page=' + pageno, res,{
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
  }

    userEditLog(res: FormData, pageno: number = 1): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/user/user_edit_log?page=' + pageno, res,{
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
  }
     ipDetailsFetch(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/user/ip_details_fetch', res,{
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
  }
  viewPassWord(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/user/view_password', res,{
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
       
  }
  
  getQtybyNameNew(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/search_rates_new', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBatchSellRate(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_batch_sell_rate', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getQtybyBarcode(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/search_rates_barcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getQtybyBarcodeNew(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/search_rates_barcode_new', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateQty(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/update_qty', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  selBranchviseQty(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/get_unit_rates_branchvise', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  batchUnitRate(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/batch_unit_rate', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBranchesWithUnits(res: FormData): Observable<Branch> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/get_branches_unit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getBatches(res: FormData): Observable<Branch> {
    return this.httpClient.post<Branch>(this.PHP_API_SERVER + '/api/stock/get_batches', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  selBranchviseUnits(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/update_sales_rates', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  removePriceGropPrd(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/remove_pricegroup_prd', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesInv(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/sales_invoice', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesInvData(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/sales_invoice_data', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesInvBranch(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/sales_invoice_bybinv', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getStockBranches(): Observable<Branch[]> {
    return this.httpClient.get<Branch[]>(this.PHP_API_SERVER + '/api/get_stock_branches', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getGodownBatchStock(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_godown_batch_stock', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getVanBatchStock(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_van_batch_stock', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getGodownStockQty(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_godown_stock_qty', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  

  getBatch(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_batch_stock', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  searchLedgerList(res: FormData, pageno): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/search_ledger_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchAccLedgerRpt(res: FormData, pageno): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/ledgers/search_acc_ledger_rpt?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchIDELedgerList(res: FormData, pageno): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/creditNote/search_ide_ledger_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchIDEDELedgerList(res: FormData, pageno): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/debitNote/search_idede_ledger_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchSupplierList(res: FormData, pageno): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/search_supplier_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchCustomerList(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/customer/search_cust_list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustomerBalance(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/get-balance', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSupplierBalance(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_supplier_balance', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustomerInvoice(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/get-pending-invoice', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getMultiCustomerInvoice(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/get-pending-invoice-multi-cust', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSupplierInvoice(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/supplier/get_supplier_pending_invoice', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSupplier(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/supplier/item', { supp_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createDueReceipt(data): Observable<any> {
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/due_rec_add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createDuePayment(data): Observable<any> {
    data.pay_date = this.formatDate(data.pay_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/due_payment_add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateDueReceipt(data): Observable<any> {
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/due_rec_update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateDuePayment(data): Observable<any> {
    data.pay_date = this.formatDate(data.pay_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/due_payment_update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllDueReceipt(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/due_rec_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllCentralizedDueReceipt(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/centralized_due_rec_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllCentralizedDueReceiptJournal(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/centralized_due_journal_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllWalletDueReceipt(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/due_rec_list_by_wallet?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidDueReceipt(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/void_due_rec', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidDuePayment(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/void_due_payment', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidWalletDueReceipt(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/void_due_rec_by_wallet', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllDuePayment(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/due_payment_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCentralizedDuePayment(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/centralized_due_payment_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCentralizedDueJournal(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/centralized_due_journal_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidWalletDuePayment(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/void_due_payment_by_wallet', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllWalletDuePayment(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/due_payment_list_by_wallet?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  branchTransfer(res): Observable<Van> {
    res.tran_date = this.formatDate(res.tran_date);
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/branchtransfer/transfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  

  branchTransferReq(res): Observable<Van> {
    res.tran_date = this.formatDate(res.tran_date);
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/stock_transfer_request/add', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }

  branchTransferReqUpdate(res): Observable<Van> {
    res.tran_date = this.formatDate(res.tran_date);
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/stock_transfer_request/update', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }

  listTransferRequest(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/stock_transfer_request/list_transfer_request?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }

  listBranchTransferRequests(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/stock_transfer_request/list_branch_transfer_request?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }

  stockSet(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/stock/stock_set', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockStatus(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/stock_status', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getAllSetStockedPrdct(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/get_all_set_stock_prdcts', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  listReceivedTransfers(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/branchtransfer/transfer_received?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listTransfers(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/branchtransfer/transfer_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  listBarcode(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/viewdetails', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  addProfile(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/addprofile', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editProfile(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/editprofile', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  editItem(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/edititem', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editBcode(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/editbarcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editPrice(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/editprice', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  editCurr(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/editcurr', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editPrate(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/editprate', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editMfg(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/editmfg', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editExp(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/editexp', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editShop(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/barcode/editshop', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  acceptOrrejectTransfer(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/branchtransfer/updateStatus', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  transferPreview(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/branchtransfer/preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  transferReqPreview(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_transfer_request/preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }


  getLedgers(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/ledger_all', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanlines(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/vanline/all', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  get_godown_tran_num(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/get_godown_tran_num', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  listSendTransfers(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/branchtransfer/send_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listSendTransfersSummary(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/branchtransfer/send_list_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listReceivedTransfersSummary(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/branchtransfer/received_list_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidTransfer(res: FormData): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/branchtransfer/transfer_void', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidTransferRequest(res: FormData): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/stock_transfer_request/void_transfer_request', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }

  listGwnTranfer(pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/godown_transfer/list?page=' + pageno, {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  setRates(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/set_rate_code', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getRates(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_rate_code', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  setChartAcntNo(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/set_chart_acnt_no', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getChartAcntNo(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/get_chart_acnt_no', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  updateTransfer(res): Observable<Van> {
    res.tran_date = this.formatDate(res.tran_date);
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/branchtransfer/update_transfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   updateTransferNew(res): Observable<Van> {
    res.tran_date = this.formatDate(res.tran_date);
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/branchtransfer/update_transfer_new', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createPayment(data): Observable<any> {
    data.pay_date = this.formatDate(data.pay_date);
    return this.httpClient.post(this.PHP_API_SERVER + '/api/payment/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updatePayment(data): Observable<any> {
    data.pay_date = this.formatDate(data.pay_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createInterPayment(data): Observable<any> {
    data.pay_date = this.formatDate(data.pay_date);
    return this.httpClient.post(this.PHP_API_SERVER + '/api/payment/inter_add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateInterPayment(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/inter_update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllPayment(curPage,res: FormData,): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/list?page=' + curPage ,res,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getPaymentLog(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/log?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllInterBranchPayment(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/inter_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllInterBranchReceipt(curPage,res: FormData,): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/inter_rec_list?page=' + curPage ,res,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidPayment(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/void', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  

  voidPDC(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/void_pdc', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }


  voidCrNotes(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/creditNote/void_cr_notes', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchCustomerSupplier(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/creditNote/search_customer_and_supplier', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidDrNotes(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/debitNote/void_dr_notes', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidSalesDrNotes(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/debitNote/void_salesdr_notes', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  rejectInterPayment(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/inter_reject', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidReceipt(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/void', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllReceipt(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  filterReceiptLog(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/log?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getReceiptLog(data,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/log?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllCurrency(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/currency/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllServiceType(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/service_type/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  getAllServiceTypesDatas(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/service_type/get_all_sevice_type', {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getAllFreightType(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/freight_type/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllPalletManagements(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/pallets_mangements/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllFilterPalletManagements(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/pallets_mangements/list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  listAllCurrency(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/currency/listall', {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  getAllSalesAgent(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/list_sales_agents?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchCustCategory(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/customer_category/search_customer_category', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listCustCategory(res:any=''): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_category/listall_customer_category', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  getAllCustCategory(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_category/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createCustomerCategory(data): Observable<any> {
  
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_category/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchCustomerCategory(data): Observable<any> {
  
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_category/search_customer_category', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustomerCategory(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_category/get_item', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

 
  updateCustomerCategory(data): Observable<any> {
    // data = this.updateDateEntry(data);
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_category/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listCustSubCategory(res:any=''): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_sub_category/listall_customer_sub_category', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createCustomerSubCategory(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_sub_category/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  viewCustomerSubCategory(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_sub_category/view', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateCustomerSubCategory(data): Observable<any> {
    // data = this.updateDateEntry(data);
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_sub_category/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  deleteCustomerSubCategory(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_sub_category/delete', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustomerSubCategory(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_sub_category/get_item', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  createLedgerGrouping(data): Observable<any> {
  
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledger_grouping/add_ledger_grouping', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getLedgerGrouping(data): Observable<any> {
  
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledger_grouping/get_all_ledger_grouping', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  changeSalesAgentStatus(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/change_sales_agent_status', { 'sa_id': id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  filterReceipt(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  filterPDC(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }


  filterCheckedPDC(data, curPage, perPage): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/datewise-pdc-list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }


  listPdc( curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/list?page=' + curPage + '&per_page=' + perPage,{},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listPdcByFilter(data:FormData, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/filter_list?page=' + curPage + '&per_page=' + perPage,data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getStockbyItem(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/stock_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesStockbyItem(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/stock_search_sales', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getSalesStockbyItemPOS(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/stock_search_pos', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getStockbyItemByIds(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/stock_search_ids', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getStockbyItemByIdsDraft(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/stock_search_ids_draft', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getGodownStock(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/stock/godown_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLedgerBalance(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledger/get-ledger-balance', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSupplierCurrencyDetails(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/get_supplier_currency_details', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
    getAllExpenseLedgers(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/get_all_expense_ledgers', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustomerCurrencyDetails(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/get_customer_currency_details', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPDCcount(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/pdc_count', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  batchExCount(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/batch/expiry_notification_count', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  

  getSalesOrdercount(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_orders/get_sale_order_count', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
    getSalesDuecount(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/get_sale_due_count', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getTransactionEditReqcount(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/get_sale_transaction_edit_req_count', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getTransactionEditRequest(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/get_sale_transaction_edit_req', null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

    getPurchaseDuecount(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase/get_PurchaseDue_count', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getEinvoicecount(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/get_pending_einvoice_count', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getInvoiceRequest(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/get_sales_invoice_request', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getDiscountInvoiceRequests(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/get_sales_discount_approve', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateDiscReqStatus(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/update_disc_req_status', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
   updateInvReqStatus(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/update_inv_req_status', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateEprnextStatus(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/update_eprnext_status', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
   checkErpNextRequest(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/check_eprnext_request', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  dateWisePDClist(data): Observable<any> {
    //  data.cheq_issue_date = this.formatDate(data.cheq_issue_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/datewise-pdc-list', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  dateWiseSOlist(data): Observable<any> {
    //  data.cheq_issue_date = this.formatDate(data.cheq_issue_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_orders/get_sale_order_pending_list', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

    dateWiseSDlist(data, pageno: number): Observable<any> {
    //  data.cheq_issue_date = this.formatDate(data.cheq_issue_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/get_sale_due_pending_list?page='+ pageno, data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   dateWisePDlist(data, pageno: number): Observable<any> {
    //  data.cheq_issue_date = this.formatDate(data.cheq_issue_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase/get_Purchasedue_pending_list?page='+ pageno, data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  batchExlist(data): Observable<any> {
      data.ex_date = this.formatDate(data.ex_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/batch/expiry_notification',data,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSupBalance(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledger/get-sup-ledger-balance', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSupInvoice(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase/get-sup-ledger-invoice', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  

  getSupPurchase(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/getSuppPurchase', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  geSalesReturnId(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/next_return_id', { cust_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getLedgerDetailRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgerReport/ledger_detail_rep', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getLedgerStatementRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgerReport/ledger_statement_rep', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLedgerDetailcode(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgerReport/ledger_detail_code', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLedgerDetailRepExcel(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgerReport/ledger_detail_rep_excel', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getNextPaymentId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/next-id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getNextExJournaltId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/next-id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getNextReceiptId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/next-id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getNextRepackingId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/repacking/next_id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getNextPdcId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/next-id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  getGodownItemwise(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godowns_item_wise', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  addDamage(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/add_damage', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getUnitsItemwise(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/units_item_wise', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchSoldProducts(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/search_sold_product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllBatchOfProduct(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_all_batch_of_product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getDamageList(curPage, res: any): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/stock/list_damage?page='+ curPage, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesItemReturn(data): Observable<any> {
    data.ret_date = this.formatDate(data.ret_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_return', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllTaxCategory(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/tax-category/getall', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createJournal(data): Observable<any> {
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateJournal(data): Observable<any> {
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  openPDF(formData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgerReport/ledger_detail_pdf', formData, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getNextJournalId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/next-id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllJournal(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllCenJournal(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/centralized_list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }


  voidJournal(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/void', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getReceipt(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/viewReceipt', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getCurrency(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/currency/get_item', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getServiceType(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/service_type/get_item', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getFreightType(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/freight_type/get_item', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteServiceType(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/service_type/void', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteFreightType(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/freight_type/void', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPDCview(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/post-dated-cheques/view', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getInvoiceDueReceipt(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/viewInvoiceDueReceipt', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getInvoiceDuePayment(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/viewInvoiceDuePayment', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getCentralizedInvoiceDuePayment(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/viewCentralizedInvoiceDuePayment', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getInvoiceDuePaymentByWallet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/viewInvoiceDuePaymentByWallet', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getInvoiceDueReceiptByWallet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/viewInvoiceDueReceiptByWallet', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPayment(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/viewPayment', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getExJournal(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/view_ex_journal', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  groupSummaryReport(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/account_report/acc_group_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  trialBalanceReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/trialbalance?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProfitAndlossReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/profitandloss?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken'),
        spracs: localStorage.getItem('spracs')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBalanceSheetReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/balancesheet?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken'),
        spracs: localStorage.getItem('spracs')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  superAccess(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/superaccess', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  changePandlPassword(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/change_pandl_password', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  verificationOfBalanceReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/verificationofbalance?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  groupSummaryToatalReport(res: FormData): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/account_report/excel_data', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  listDaybook(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/account_report/dayBook?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listDialySummay(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/dialy_summary_reports?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listCustomerDet(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/customer_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  searchCustomerDet(data, pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_summary?page=' + pageno,data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  CustomerDet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_summary/cus_details', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  VouchersDet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_summary/vouchers_details', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  VouchersDetMultiCust(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_summary/vouchers_details_multi_cust', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchVoucherType(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/search_voucher_type', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  listSupplierDet(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/purchase_report/supplier_summery?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchSupplierDet(data, pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/supplier_summery?page=' + pageno,data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  supplierDet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/supplier_details', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  VoucherSupplierDet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/supplier_vouchers_details', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  walletTracking(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/purchase_report/wallet_tracking?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  paymentwalletSupplierDet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/payment_wallet_details', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchSupplierpaymentDet(data, pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/supplierpayement_det?page=' + pageno,data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  custmerWalletTracking(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/customer_wallet?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  custmerSalesAndReturnSummary(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/sales_report/customer_sales_and_return_sumary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getOutstandingRecievable(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_report/outstanding_recievable_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchCustomerpaymentDet(data, pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_wallet/searchcustomer?page=' + pageno,data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  recieptwalletSupplierDet(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer_wallet/customerpayment?page=', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  salesReturnList(res: FormData, pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_return_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesReturnVoidList(pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_return_void_list?page=' + pageno, {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  inputVatReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/vat_report/input_vat_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  inputExpenseVatReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/vat_report/input_expense_vat_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  DailyVatReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/vat_report/day_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  outputVatReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/vat_report/output_vat_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  salesVoid(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales_report/sales_void', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesDet(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales_report/sales_det', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  readbranchTransfersItemReport(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/stock_tran_report/product_based?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  readbranchTransfersItemReportAll(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/stock_tran_report/summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }





  readbranchTransfersItemReceivedReport(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/stock_tran_report/product_received?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  getSalesReturnInv(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/sales_return_invoice', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getJournal(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/viewJournal', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  salesReturnVoid(res: FormData): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales_report/sales_return_void', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchjournalList(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/journal/search_list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllBankLedgers(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_bank_ledger', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllCashAccount(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_cashInhand_ledger', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  salesReturnSummary(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/return_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getnextContraId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/contra/next-id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  createContra(data): Observable<any> {
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/contra/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateContra(data): Observable<any> {
    data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/contra/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getAllcontra(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/contra/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getContra(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/contra/viewContra', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidContra(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/contra/void', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getsalesReturnPrev(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_return_preview', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }




  searchDuelList(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/due_rec_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchWalletDuelList(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/due_rec_list_by_wallet?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchPaymentlList(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/due_payment_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchWalletPaymentList(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/due_rec_list_by_wallet?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }


  searchContraList(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/contra/search_list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  searchPaymentList(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchJournalList(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  filterPaymenttLog(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/log?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }



  ledgerList(data: FormData, pageno): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgerReport/ledger_list?page=' + pageno, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  salesItemReturnWithInv(data): Observable<any> {
    data.ret_date = this.formatDate(data.ret_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_return_inv', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateDateEntry(info) {
    Object.keys(info).forEach((k, i) => {
      if (typeof info[k] === 'object' && info[k] instanceof Date) {
        info[k] = this.formatDate(info[k]);
      }
    });
    return info;
  }

  updatePrivilages(data: FormData) {
    return this.httpClient.post<User>(this.PHP_API_SERVER + '/api/privilage/update_privilage', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getMenuByGroup(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/menu/get_menu_by_group', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getsaleReturnTotal(res: FormData): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/get_sales_and_return_total', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesDashboardDet(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/get_sales_dash_det', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getAccGroup(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/search_acc_group', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getUserPrivilages(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/privilage/get_user_privilages', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getUserPalletType(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/privilage/get_user_pallet_types', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getUserOtherPrivilage(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/privilage/get_user_other_privilages', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updatePrivilage(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/privilage/update_privilage', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  isLedgerDeletable(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/isLedgerUsed', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  isCustomerDeletable(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/isCustomerUsed', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  isSupplierDeletable(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/ledgers/isSupplierUsed', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  DeleteLedger(res: FormData): Observable<Supplier> {
    return this.httpClient.post<Supplier>(this.PHP_API_SERVER + '/api/delete_ledger', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  DeleteCustomer(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/delete_customer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  DeleteSupplier(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/delete_supplier', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listGodown(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/godown/list', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listAllGodown(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Vanline>(this.PHP_API_SERVER + '/api/godown/list_all?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  openingbalanceSummaryReport(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/account_report/opening_balance_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   monthlyExpenseReport(res: any, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/account_report/monthly_expense_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  addAsCustomer(res: Ledger): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/addLedgAsCustomer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  addAsSupplier(res): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/addLedgAsSupplier', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addResArea(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/addResArea', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getResArea(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/getResArea?page=' + pageno, res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateResArea(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/updateResArea', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   deleteResArea(data: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/deleteResArea', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addResTables(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/addResTables', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getResTables(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/getResTables?page=' + pageno, res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPosOrderList(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/getPosOrderList?page=' + pageno, res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  getSoldPosOrderList(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/get_sold_pos_order_list' , res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateResTables(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/updateResTables', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateTableStatus(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/update_table_status', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createAddonProd(product: any): Observable<Product> {
    return this.httpClient.post<Product>(this.PHP_API_SERVER + '/api/new_addon_product', product, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSetStockedProdList(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_setStocked_prod_list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updatePosSetting(res) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/update_pos_setting', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updatePrinters(res) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/update_printers', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPosSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/get_pos_setting',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getPrinters(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/restaurant/get_printers',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSystemPrinters(url): Observable<any> {
    return this.httpClient.get<any>(url + 'get_printers', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
      })
    }).pipe(catchError((error) => {
       console.error('API Error:', error);
        return throwError(() => new Error('Printer Module Not Working, OR Not Installed.'));
      }
    ));
  }
  getDeviceId(url): Observable<any> {
    return this.httpClient.get<any>(url + 'get_device', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
      })
    }).pipe(catchError((error) => {
       console.error('API Error:', error);
        return throwError(() => new Error('Printer Module Not Working, OR Not Installed.'));
      }
    ));
  }
  printDiv(url,data): Observable<any> {
    return this.httpClient.post<any>(url + 'print', data,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
      })
    }).pipe(catchError((error) => {
       console.error('API Error:', error);
        return throwError(() => new Error('Printer Module Not Working, OR Not Installed.'));
      }
    ));
  }

  voidDamage(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/void_damage', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getPurchInv(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/getoldPurchInv', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  sqlConnect(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sqlConnect', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updatePurchase(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/updatePurchase', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  // UpdateGoodsReceipt(res: FormData): Observable<any> {
  //   return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/goods_receipts/update_goods_receipt', res, {
  //     headers: new HttpHeaders({
  //       'Access-Control-Allow-Origin': '*',
  //       Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
  //       cmptoken: localStorage.getItem('cmptoken')
  //     })
  //   }).pipe(catchError((error) => this.checkServerError(error)));
  // }

  UpdateGoodsReceipt(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/goods_receipts/update_goods_receipt', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  formatDate(date) {
    if (date) {
      const d = new Date(date);
      console.log(d);
      
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      const year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      return [year, month, day].join('-');
    } else {
      return '';
    }
  }
  formatTime(date) {
    const d = new Date(date);
    let hour = '' + d.getHours();
    let min = '' + d.getMinutes();
    let ss = '' + d.getSeconds();
    if (hour.length < 2) {
      hour = '0' + hour;
    }
    if (min.length < 2) {
      min = '0' + min;
    }
    if (ss.length < 2) {
      ss = '0' + ss;
    }
    return [hour, min, ss].join(':');
  }


  getLedgerPrivilages(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledger_privilage/get_ledger_privilages', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateLedgerPrivilage(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledger_privilage/update_privilage', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listGodownbyBranch(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/godown/list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  damageSummaryReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product_report/damage_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  productCommisionReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product_report/product_commision?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  productCatgoryReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product_report/product_category?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesChart(pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_report/chart', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPurchaseChart(pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_report/chart', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateMultiBrachStockRate(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/update_multi_branch_rates', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTransferLedgers(res: FormData): Observable<Group> {
    return this.httpClient.post<Group>(this.PHP_API_SERVER + '/api/branch_ledgers', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  edilogSumPage(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/purchase_report/editlog?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateSettings(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/update_templete', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addBarcodeTemplate(data: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/add_barcode_template', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateBarcodeTemplate(data: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/update_barcode_template', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBarcodeTemplate(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/get_barcode_template?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deletedBarcodeTemplate(data: any): Observable<Product> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/delete_barcode_template', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addPrintTemplate(data: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/add_print_template', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPrintTemplate(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/get_print_template?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getActivePrintTemplate(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/get_active_print_template', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  changeActivePrintTemplate(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/change_active_print_template', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deletePrintTemplate(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/delete_print_template', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  checkPrintTemplate(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/check_template_name', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  uploadPrintTemplateImg(res: any): Observable<any> {

    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print-image?cmptoken=' + localStorage.getItem('cmptoken'),res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  uploadCommonTempImg(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/upload_common_temp_img', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteCommonTempImg(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/delete_common_temp_img', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addTempToAllBranches(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/add_temp_all_branch', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPrintTemplateDet(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/get_prnt_temp_details', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSettings() {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/print_settings/get_templete', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  aging(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_outstanding_receivable', res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  supaging(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_outstanding_payable', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  saleAnalysis(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_sales', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseAnalysis(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_purchase', res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  topProduct(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_top_sold_prods', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTopCustomers(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_top_customers', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTopSuppliers(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_top_suppliers', res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTotalSale(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_total_sale',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getTotalQuantity(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_total_qty', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getTotalPurchase(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_total_purchase', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getTotalStockTransfer(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_total_stock_transfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getTotalReceiptAndPayment(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/dashboard/get_total_receipt_payment', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAdminDashboard(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/dashboard/get_admin_dashboard', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTotalStock(formData: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_total_stock', formData, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTotalCashinHand(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_cashinhand_total', res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTotalCashinBank(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_cashinbank_total', res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVat(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard/get_vat', res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getDashNotification(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/dashboard/get_notification', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  cashCreditPurchase(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/purchase_report/cash_credit_purchase?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesAuditor(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/sales_auditor?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  branchTransferAuditor(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/stock_tran_report/branch_transfer_auditor?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  expensesReport(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/account_report/expense_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBranchbyType(res: FormData): Observable<Branch[]> {
    return this.httpClient.post<Branch[]>(this.PHP_API_SERVER + '/api/get_branches_by_type', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  bankReportAuditor(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/account_report/bank_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  detailedBankReportAuditor(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/account_report/bank_report_detailed?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  employeeReportAuditor(res: FormData, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/account_report/employee_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  DailyVatSummary(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/vat_report/day_summary1', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  DailyVatDetailedSummary(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/vat_report/day_summary_datewise', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllTaxCategoryIds(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/tax-category/getallcatids', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getMissingStockList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/stock/list_misiing_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addtoMissingStock(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/add_missing_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesDetailAuditor(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/sales_detail_auditor?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidMissingStock(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/void_missing_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidAllMissingStock(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/void_all_missing_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addExcessStock(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/add_excess_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getExcessStockList(res: any,pageno): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/stock/list_excess_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getStockbyBarcode(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/stock_search_by_barcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getStockbyBarcodePurchase(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/stock_search_by_barcode_purchase', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getStockbyBarcodeSales(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/stock_search_by_barcode_sales', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getOpeningUnit(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_opening_unit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  openingStockSearchBarcode(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_search/product_search_barcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidExcessStock(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/void_excess_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidAllExcessStock(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/void_all_excess_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  misiingStockSummaryReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/misiing_stock_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  excessStockSummaryReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/excess_stock_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  lowStockAlert(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/low_stock_alert?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  excessStockAlert(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/excess_stock_alert?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateRateCodeEncp(data: FormData) {
    return this.httpClient.post<User>(this.PHP_API_SERVER + '/api/privilage/update_rate_code_encp_type', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLowStock(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/dashboard/get_low_stock', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getExcessStock(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/dashboard/get_excess_stock', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  branchTranInvBased(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_tran_report/branch_trans_inv_based?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  analyseUnusedProds(data: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/analyse_unwanted_prods',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  analyseInactiveLedgers(data: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/analyse_inactive_ledgers',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  removeUnusedProds(data: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/remove_unwanted_prods',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  removeInactiveLedger(data: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/remove_inactive_ledgers',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  branchReciInvBased(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_tran_report/branch_reci_inv_based?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockVerify(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/verify_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  resetStockToZero(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/reset_stock_zero', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getNonZeroStockCount(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_non_zero_stock_count', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  verifyStockBulk(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/verify_stock_bulk', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getStkVerfExcelRowCount(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_stk_vrfy_excel_row_count' , res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }
  pdtStockVerify(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/pdt_verify_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  pdtStockVerifyCount(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/pdt_verification_count', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  tempStockVerifyItem(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/temp_verify_stock_item', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanStockVerify(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/van_verify_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  superAccessAdvancedSettings(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/privilage/check_advance_setting_access', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getStockbyGodown(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/stock/get_stock_by_godown', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getStckVrfyRefNum(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_stock_vrfy_ref_no', '',{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanStckVrfyRefNum(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/get_van_stock_vrfy_ref_no', '',{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getStckVrfyhstry(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_stock_vrfy_histry', res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanStckVrfyhstry(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/get_van_stock_vrfy_histry', res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVerifiedStockList(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/stock_vrfy_list?page=' + pageno, res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTempVerifiedStockList(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_temp_stock_verified_list?page=' + pageno, res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getVanVerifiedStockList(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/van_stock_vrfy_list?page=' + pageno, res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockVerifyByLog(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/verify_stock_by_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  stockVerifyByLogVan(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/verify_stock_by_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteTempVerDta(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/delete_temp_ver_data', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockVerificationSummary(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/stock_verification_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  purchaseDetailSummary(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/purchase_report/purchase_detail_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  unverifiedStockSummary(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/unverified_stock_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  stockUnverifiedProduct(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/unverified_product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  readVanStockTracking(res: FormData, pageno: number): Observable<Vanline> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van_transfer/van_stock_tracking?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

    vanRouteWiswClosingRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_reports/routewise_closingrep', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  vanDistributorsRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_report/distributors', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanDistributorsRep2(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_reports/distributors_2', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  vanDetailedRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_report/detailed', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanCustTransactionRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_reports/van_cust_transaction', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanCollectionRep(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_reports/van_collection_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  vanStockverifyRep(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_reports/van_stock_verify_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanSaleMonthlyReport(res: any, pageno: number): Observable<Reppurchsum> {
    return this.httpClient.post<Reppurchsum>(this.PHP_API_SERVER + '/api/van_reports/van_sales_monthly_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  branchDetailedRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_tran_report/branch_detailed_rep', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  itemTrackingRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/item_tracking_rep', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  itemMovementDetails(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/item_movement_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getUploadedBarcodeList(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/list_stck_barcode?page=' + pageno, res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  uploadBarcodeFile(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/upload_barcode', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBarcodeList(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_barcode_list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  godwnPrdoductStock(res: FormData,pageno: number) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_stock_by_gd?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPurchaseProduct(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock_search/get_purch_prod', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getUnitSalesRate(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/get_unit_sales_rate', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPurchaseProduct1(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock_search/get_purch_prod1', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  palletMangmntReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/pallets_mangements/pallets_management_rep?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  itemUnitWiseTarckingReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/item_unitwise_tracking?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  freeGoodsReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/free_goods_reports?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   repackingReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/repacking/repacking_reports?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockVerificationInvBasedRep(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/stock_verifictn_inv_based?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  InvoicedueRecSummary(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/due_recipt_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  InvoiceduePaymentSummary(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/purchase_report/due_payment_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updatePurchSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_setting/update_purch_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateGdsRcptSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_setting/update_gds_rcpt_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPurchSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_setting/get_purch_setiing',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
    jobOrderSearch(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/job_order_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  
  getAllJobOrder(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  createJobOrder(data): Observable<any> {
    data.start_date = this.formatDate(data.start_date);
    data.end_date = this.formatDate(data.end_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   updateJobOrder(data): Observable<any> {
    data.start_date = this.formatDate(data.start_date);
    data.end_date = this.formatDate(data.end_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateJobOrderStatus(data): Observable<any> {
    data.start_date = this.formatDate(data.start_date);
    data.end_date = this.formatDate(data.end_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/update_status', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getJobOrderRefNo(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/get_jo_ref', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createStatus(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/add_status', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getJobOrder(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/get_job_order', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getJobOrder2(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/get_job_order2', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteJobOrderSub(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/delete_sub', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getJobDetails(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/report', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  allJobOrderReport(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/job_order/all_job_order_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createSrcOfLead(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/add_src_of_lead', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateDasboardSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard_setting/update_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateAdminDasboardSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard_setting/update_admin_dashboard', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getDasboardSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/dashboard_setting/get_setiing',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_sales_setiing',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesReturnSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_return_setting/get_sales_return_settings',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getVoucherSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/voucher_settings/get_voucher_setiing',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getMailSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/mail_setting/get_mail_setting',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateMailSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/mail_setting/update_mail_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  loyaltySubmit(data: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/loyalty_add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCategoryLoyalty(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/get_category_loyalty', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
    getAllCategoryLoyalty(data: FormData,pageno) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/loyalty_get_all?page=' + pageno, data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
    loyaltySettingsUpdate(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/loyalty_settings_update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getLoyaltySettings(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/get_loyalty_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
 
  getVanDiscountSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_van_discount_settings',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getPrefixSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_prefix_settings',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getMenuMaster(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_menu_master',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAdminNotification(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_admin_notification',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateAdminNotification(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_admin_notification', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateSalesSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_sales_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateCustmPrntSalesSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_custm_prnt_sales_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateSalesReturnSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_return_setting/update_sales_return_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateGodownSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_godown_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPriceChekerSettings(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_price_checker_setting',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updatePriceChekerSettings(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_price_checker_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateSalesQtnSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_sales_qtn_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateSalesOrderSettings(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_sales_order_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
   updateMapSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/api_settings/update_map_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getMapSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/api_settings/get_map_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateUPISetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/api_settings/update_upi_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updatewhatsAppSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/api_settings/update_whatsapp_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateEPDSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/api_settings/update_epd_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  whatsAppLinkGenerate(data: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/whatsapp_api/link_genrate', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateVoucherSettings(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/voucher_settings/update_voucher_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updatePrintStyle(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_print_style', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateSOPrintStyle(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_so_print_style', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateDNPrintStyle(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_dn_print_style', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllNonCashLedgers(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_non_cash_ledgers', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getDebitAllNonCashLedgers(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_non_cash_ledgers',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCashBankBookRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/cash_and_bank_book', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCashBookRep(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/cash_book', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getDefaultLedgers(res: FormData): Observable<Group> {
    return this.httpClient.post<Group>(this.PHP_API_SERVER + '/api/default_ledgers', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getDefaultallLedgers(res: FormData): Observable<Group> {
    return this.httpClient.post<Group>(this.PHP_API_SERVER + '/api/account_report/default_ledgers', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPurchaseList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/purchase/list_purchase?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getGoodsReceiptsList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/goods_receipts/list_goods_receipts?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getPurchaseQtn(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/purchase/get_qtn_num', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addPurchQuatation(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/add_purchase_qtn', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getNextPurchaseQtn(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/purchase/get_qtn_num', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getPurchaseQtnList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/purchase/list_quatation?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPendingPurchase(res: any): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/purchase/pending_purchase', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidpurchaseorderitem(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase/void_purchase_order_item', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getpurchQtnDetails(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/purchase/quatation_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updatePurchaseQtn(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/updatePurchaseQtn', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLowStockProds(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.PHP_API_SERVER + '/api/get_low_stock_prods', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdByCat(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_prod_by_cat', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdByIds(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_prod_by_id', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdDetByCat(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_all_prods_by_cat?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getProdDetByCatNew(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/get_all_prods_by_cat_new?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getOfferProdDetByCat(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/get_all_prods_by_cat?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getOfferProdDetBySubCat(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/get_all_prods_by_sub_cat?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getProductDet(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/get_all_prods_det'  , res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getSpecialPriceProducts(value): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/get_special_price_products', value, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllExportCompany(value): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/export_company/list', value, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllPrdcode(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_all_prodcode', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdDet(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_product_detail', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateMultiProds(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/update_multiple_prods', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

    addProdLocation(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/add_product_location', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  addProductCommision(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/privilage/add_product_commision', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getProdBylocation(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_product_loctn', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getGodownWiseStock(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godown_stock/get_stock_gdnwise', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanTranReq(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/van/get_van_transfer_req_data', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanTranReqReject(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/van/van_transfer_req_reject', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockBranchTransferReqReject(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/stock_transfer_request/stock_branch_transfer_req_reject', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }
  getProductStock(res: FormData): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godown_stock/get_product_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
   getRentalGodown(res: FormData): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godown_stock/get_rental_gd', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProductSlNo(res: FormData): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godown_stock/get_product_sl_no', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProductBatches(res: FormData): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godown_stock/get_product_batches', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getGodownBatchStockTotal(res: FormData): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/godown_stock/get_godown_batch_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getBranchWiseStock(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/get_branchwise_stocks', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getsaleProdDetails(res: FormData): Observable<any> {
    if(res.get('date')){
      res.set('date', this.formatDate(res.get('date')));
    }
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/get_prod_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  gettrnsferinfProdDetails(res: FormData): Observable<any> {
    if(res.get('date')){
      res.set('date', this.formatDate(res.get('date')));
    }
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/interstocktrnsfer/transering_prod_detials', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  trnsferingProdDetails(res: FormData): Observable<any> {
    if(res.get('date')){
      res.set('date', this.formatDate(res.get('date')));
    }
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/interstocktrnsfer/transering_prod_detials_new', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  gettrnsferinfProdDetailsAll(res: FormData): Observable<any> {
    if(res.get('date')){
      res.set('date', this.formatDate(res.get('date')));
    }
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/interstocktrnsfer/transering_prod_detials_all', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }

  getExTransProdDetails(res: FormData): Observable<any> {
    if(res.get('date')){
      res.set('date', this.formatDate(res.get('date')));
    }
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/externalstocktransfer/search_ext_stk_transfer_product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockByUnit(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_stock_by_unit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLastSaleToCust(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/last_inv_to_cust', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addSalesQuotation(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/add_quotation', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSaleQtRefNo(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/get_qt_ref', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  draftSalesQuotn(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/draft_quotation', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCustomerByCode(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/search_cust_code', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesDraftList(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/list_drafts', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  copyTransferRef(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/copy_ref', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  copySalesRef(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/copy_sale', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  removeSalesDraft(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/remove_drafts', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesDraft(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/get_draft_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesQtnList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/list_sales_qtn?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getExternalStockTransList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/externalstocktransfer/list_external_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listExtStockTransferVoid(searchval, pageNo): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstocktransfer/list_void?page=' + pageNo, searchval, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getExternalStockRecipList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/externalstockreceipt/list_external_reciept?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesQtnListWithNotes(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/list_sales_qtn_with_notes?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSalesQtn(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/get_qtn_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
 
  updateSalesQuotation(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/update_quotation', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  geteditSalesItem(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/edit_item', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesQtnPreview(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/get_qtn_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getSaleRefNo(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/get_sales_ref', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  addSales(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/add_sales', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addAttachments(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/add_attachments', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  deleteAttachedFile(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/delete_attachments', { attachment_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  eInvoiceResubmit(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/einvoice_resubmit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  blueGlobalSubmit(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/blue_global_submit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  blueGlobalUpdateStatus(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/blue_global_update_status', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  addCreditNotes(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/creditNote/add_credit_notes', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addDebitNotes(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/debitNote/add_debit_note', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addSalesDebitNotes(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/debitNote/add_salesdebit_note', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addCustAttachedFile(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/customer/add_attach_files', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesInvList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/list_sales_inv?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSalesdescription(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/sales_descipt?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSalesInvLogList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/list_edit_log?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getvanTransferLogList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/van/list_edit_log?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanTrnfReqList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/van/list_van_transfer_requests?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getVanTrnfReqProducts(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/van/list_van_transfer_requests_products?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  

  searchCrNList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/creditNote/list_cr_notes?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchDrNList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/debitNote/list_dr_notes?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   searchSalesDrNList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/debitNote/list_salesdr_notes?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCrNoteList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/creditNote/list_cr_notes?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getDrNoteList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/debitNote/list_dr_notes?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getSalesDrNoteList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/debitNote/list_salesdr_notes?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getSalesInvPreview(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/get_inv_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  dotMatrixExe(res: any): Observable<any> {
    const port = localStorage.getItem('dot_matrix_port') || '5050';
    return this.httpClient.post<any>('http://localhost:' + port, res, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  getSalesParentInvPreview(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/get_parent_inv_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCrNotePreview(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/creditNote/cr_note_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getDrNotePreview(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/debitNote/dr_note_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesDrNotePreview(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/debitNote/sdr_note_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  productionVoidPreview(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/production/void_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  productionApprove(searchval): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/production/production_approve', searchval, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLedByNature(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/search_ledger_by_nature', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addAgent(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/add_sales_agent', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchAgents(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/search_sales_agents', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchAccLedger(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/payment/search_ledger_by_acc_group', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  

  searchSrcOfLead(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/sales/search_src_of_lead', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchCustCode(res: FormData): Observable<Ledger> {
    return this.httpClient.post<Ledger>(this.PHP_API_SERVER + '/api/customer/custcode_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllAgents(res:any=''): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_all_sales_agents', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllSrcOfLead(res:any=''): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/get_all_src_of_lead', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesDet(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/get_sale_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getsalesinvoicecopyDetails(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER +'/api/sales/get_copy_sale_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  getConvertSalesDet(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/get_convert_sale_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesDetails(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/get_sales_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCrNoteDet(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/creditNote/get_cr_note_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getDrNoteDet(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/debitNote/get_dr_note_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesDrNoteDet(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/debitNote/get_salesdr_note_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editSales(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/edit_sales', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editCrNote(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/creditNote/edit_cr_note', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editDrNote(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/debitNote/edit_dr_note', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editSalesDrNote(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/debitNote/edit_salesdr_note', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLogPreview(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/get_log_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getChallanNo(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/get_challan_no', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  addChallan(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/add_challan', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getDeliveryChallanList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/list_delivery_challan?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getDeliveryChallanListLastYear(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/list_delivery_challan_last_year?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getDelChallanPreview(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/get_del_challan_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getDelChallanDet(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/get_del_challan_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  editChallan(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/edit_challan', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getLastChallanToCust(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/last_challan_to_cust', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getChallanLogPreview(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/get_challan_log_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getEditChallanItem(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/edit_challan_item', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importPurchaseQtn(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase_qtn_import', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getPayrollSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payroll_settings/get_setting',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updatePayrollSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payroll_settings/update_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getDepByName(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/search_departments', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createDep(dep: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/add_department', dep, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateDep(dep: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/update_department', dep, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getDedByName(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/search_deductions', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllDeductions(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/deductions/list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  changeDedStatus(id: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/deductions/activate', { 'id': id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createDed(dep: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/add_deduction', dep, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateDed(dep: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/update_deduction', dep, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAddByName(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/search_additions', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllAdditions(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/additions/list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  changeAddStatus(id: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/additions/activate', { 'id': id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createAdd(dep: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/add_addition', dep, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateAdd(dep: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/update_addition', dep, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getDesByName(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/search_designations', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createDes(des: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/add_designations', des, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateDes(des: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/update_designations', des, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createEmployee(employee: any): Observable<Employee> {
    return this.httpClient.post<Employee>(this.PHP_API_SERVER + '/api/add_employee', employee, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getEmployeesList(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/employees_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getCompanyLeaveList(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/company_leave/list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  saveHoliday(attedance: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/company_leave/add', attedance, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  deleteLeave(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/company_leave/remove', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getEmpPayroll(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/emp/get_payroll', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getEmployeesAttendanceList(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/emp/attendance_list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  saveEmployeeAttendance(attedance: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/emp/save_attendance', attedance, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  deleteEmployee(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/remove_employee', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateEmployee(employee: any): Observable<Employee> {
    return this.httpClient.post<Employee>(this.PHP_API_SERVER + '/api/edit_employee', employee, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getDocList(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/document_list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateDoc(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/edit_doc_expiry', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getEmpReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/emp_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importCustomersByLog(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/import_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  importLedgersByLog(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/import_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importLedgersByLogtoRemove(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/import_log_to_remove', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importProductsByLogtoRemove(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product_remove/import_log_to_remove', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  removeProductsByLog(res: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product_remove/remove_products', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  storeCustomersByLog(res: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/store_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  storeLedgersByLog(res: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/store_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  removeLedgersByLog(res: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ledgers/remove_ledgers', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchMenu(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/search_menu', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  topProducts(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/top_sold_prods_report?page=' + pageno, res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken')
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }

  topCustomer(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/top_customers_report?page=' + pageno, res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken')
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }

  topSupplier(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/top_suppliers_report?page=' + pageno, res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken')
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }
  importProductExcel(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product-import' , res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }
 importProductExcelNew(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/import' , res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }
  importProductExcelNewSameUnit(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/import_with_same_unit' , res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }
  convertExcel(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/convert_excel' , res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }
  convertExcelBarcode(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/convert_excel_barcode' , res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getExcelRowCount(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/get_excel_row_count' , res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importOpeningStock(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/import_opening_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  pdfImport(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase/pdf-import', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  storeOpeningStockExcel(res: FormData ) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/store_opening_stock_excel', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProductDetails(prd_id): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/product-details/' + prd_id, {headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken')
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getBranchCashAccount(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/get_branch_cash_account', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importSuppliersByLog(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/import_supplier_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  storeSuppliersByLog(res: any) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/customer/store_supplier_log', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  copyStockDifferentBranch(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/copy_stock_different_branch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllTaxCategories(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/tax-category/getalltaxcat', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  createExpanseTaxPayment(data): Observable<any> {
    data.pay_date = this.formatDate(data.pay_date);
    return this.httpClient.post(this.PHP_API_SERVER + '/api/payment/addexptax', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createExpanseTaxJournal(data): Observable<any> {
    data.pay_date = this.formatDate(data.pay_date);
    return this.httpClient.post(this.PHP_API_SERVER + '/api/journal/addexptax', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateExpanseTaxPayment(data): Observable<any> {
    data.pay_date = this.formatDate(data.pay_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/updateexptax', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateExpanseTaxJournal(data): Observable<any> {
    data.pay_date = this.formatDate(data.pay_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/updateexptax', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllExpenceTaxPayment(res,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/exptax_list?page=' + curPage + '&per_page=' + perPage, res,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllCentralizedExpenceTaxPayment(res,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/centralized_exptax_list?page=' + curPage + '&per_page=' + perPage, res,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllExpenceTaxJournal(res,curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/exptax_list?page=' + curPage + '&per_page=' + perPage, res,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  gettaxSuppByName(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/exptax_supp_list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  gettaxSuppByVatNo(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/exptax_supp_by_vat_no', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getTaxPayment(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/viewTaxPayment', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getTaxJournal(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/viewTaxJournal', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  copySalesQtnToSale(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales/copy_qtn_to_sale', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateStockPurchRate(res: Stockedit): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/stock/updatepurchrate', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getTrasferSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/inter_branch_trasnfer_setting/get_setting',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateTransferSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/inter_branch_trasnfer_setting/update_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPrdSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product_setting/get_setting',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updatePrdSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product_setting/update_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  dlChallanSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_dl_challan_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_van_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  prefSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/updte_pref_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
unitExeption(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/unit_exception', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
blockTransactionSetting(data: any): Observable<any> {
  return this.httpClient.post<any>(`${this.PHP_API_SERVER}/api/sales_setting/block_transaction`, data, {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
      'Content-Type': 'application/json'
    })
  }).pipe(catchError((error) => this.checkServerError(error)));
}
  
  updateSingleSettings(data) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_db_close_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listExtStockTransfer(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstocktransfer/list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getNextStockTransId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstocktransfer/next_tran_id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllSundryCrDrLedgers(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/getsundrycrdrledgers',{}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  extStockTransfer(res): Observable<Van> {
    res.tran_date = this.formatDate(res.tran_date);
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/externalstocktransfer/transfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getExtTransferInfo(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstocktransfer/getsingleTransfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  extStockTransferUpdate(res): Observable<any> {
    res.tran_date = this.formatDate(res.tran_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstocktransfer/update', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidExtStockTransfer(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstocktransfer/void', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  listExtStockReceipt(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstockreceipt/list?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getNextStockRecId(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstockreceipt/next_tran_id', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  extStockReceipt(res): Observable<Van> {
    res.tran_date = this.formatDate(res.tran_date);
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/externalstockreceipt/create', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getExtReceiptInfo(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstockreceipt/getsingle', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  extStockReceiptUpdate(res): Observable<any> {
    res.tran_date = this.formatDate(res.tran_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstockreceipt/update', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidExtStockReceipt(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/externalstockreceipt/void', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  extTranInvBased(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ext_tran_report/ext_trans_inv_based?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  extReciInvBased(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ext_tran_report/ext_reci_inv_based?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  extTranDet(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/ext_tran_report/ext_trans_details?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  extReciDet(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/ext_tran_report/ext_reci_details?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  extReturnInvBased(searchval, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/ext_tran_report/ext_return_inv_based?page=' + pageno, searchval, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  extReturnDetailReport(formdata: any, pageno: any): Observable<any> {
      return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ext_tran_report/ext_return_detail?page=' + pageno, formdata,{
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  expTaxPaymentReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/exptax_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  journalReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/journal/journal_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  recieptReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/receipt_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getLastPurchaseOfProd(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/purchase/get_last_pruch_of_product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getClientSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/client_settings/get_client_settings',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getClientSettingBykey(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/client_settings/get_client_setting_by_key',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllClientSettings(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/client_settings/get_all_client_settings',{}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
 getBlockTransactionSettings(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_block_transaction_settings',{}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAdminBlockTransactionSettings(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_admin_block_transaction_settings',{}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateClientSettings(data) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/client_settings/update_client_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getEnbaleDisableModuleSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/enable_dsable_module/get_settings',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getEnbaleDisableModuleSettingBykey(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/enable_dsable_module/get_setting_by_key',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateEnbaleDisableModuleSettings(data) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/enable_dsable_module/update_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPriceGroups(curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/list?page=' + curPage + '&per_page=' + perPage, {},
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPriceGroupsExport(data, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/export_list?page=' + pageno, data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   filterPriceGrp(data, curPage, perPage): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/filter_list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPriceGroupsInfo(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/get_price_grp_info_by_prd',data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importPriceGroupByLog(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/import_by_log', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


   storePriceGroupByLog(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/store_by_log', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

 

    createPriceGroup(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updatePriceGroup(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updatePriceGroupNew(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/update_pricegroup_new', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPriceGroupById(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/getbyid', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPriceGroupProductAndRate(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/price_group/list_all_product_and_rate', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchVanProductsExtStkTrans(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/van_transfer/search_ext_stk_transfer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchProductsForTransFer(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/interstocktrnsfer/product_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  searchProductsForTranrequest(res: FormData): Observable<Van> {
    return this.httpClient.post<Van>(this.PHP_API_SERVER + '/api/interstocktrnsfer/all_product_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }
  uploadStckVerfiyByDate(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/verify_stock_by_date', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  rateUpdateWithExcel(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/rate_update_with_excel', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  submitStckVerfiyByDate(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/verify_stock_by_date_submit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importSalesValidate(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/import_sales_validate', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  uploadDatacleareExcel(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/data_clear_using_excel', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
    uploadapplications(res: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/upload_application', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importSales(res) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/import_sales', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  removeWriteOff(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/receipt/remove_writeOff', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  removePayWriteOff(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/payment/remove_writeOff', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  topSheetReport(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van/top_sheet',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  vanProfitLossReport(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_reports/van_profit_loss',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanDashboardReport(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_reports/van_dashboard',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  incomeExpenseReport(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/account_report/income_expense_report',data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getPrdByCatId(id: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/getall_prd_by_cat/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  productUnitDetails(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product_unit_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  productDetailsreport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product_detailed_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  

  weightScaleItems(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/weight_scale_items?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getUnitByPrdId(id: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/getall_unit_by_prod/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  stockUnitDetails(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_report/unit_wise_stock_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  vanStockTrackingUnitWise(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_transfer/van_stock_tracking_unitwise?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  vanItemtWiseTracking(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_report/van_itemwise_tracking?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanVisitingReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_report/van_visiting_report?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getVanStock(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/van_stocks', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem('auth_token'),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }



  unitPrdtWise(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/get_unit', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanProducts(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/get_van_products?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addtoVanMissingStock(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/add_van_missing_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addtoVanDamage(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/add_van_damage', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addtoVanExcessStock(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/add_van_excess_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchCostCenter(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/costcenter/search_cc', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanMissingStockList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/list_van_misiing_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanDamageList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/list_van_damage?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidVanMissingStock(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/void_van_missing_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidVanDamage(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/void_van_damage', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getVanExcessStockList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/list_van_excess_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchCostCenterSub(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/costcenter/search_ccs', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCatByPrdId(id: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/getall_cat_by_prd/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidVanExcessStock(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/void_van_excess_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchCostCatgory(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/costcenter/search_ccat', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  vanMissingStkRep(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_report/van_missing_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  costCategoryReport(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/costcenter/cost_cat_rpt', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProductExcessItem(res: FormData): Observable<Stockedit> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/van_stock/excess_search_product', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllCostCentId(id: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/get_cost_cent/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  excessVanStockSummaryReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/excess_van_stock_summery?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   vanDamageStockSummaryReport(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van_stock/van_damage_stock_summery?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  salesOrderApprove(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales_orders/sales_order_approve', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  transactionEditApprove(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/transaction_edit_approve', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  transactionEditApproveOrReject(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales/transaction_edit_approve_or_reject', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllCostCentSubId(id: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/get_cost_cent_sub/' + id, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addSalesOrder(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales_orders/add_sales_order', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
 
    updateKotPrintStatus(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales_orders/update_kot_print_status', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getsalecopyDetails(res: FormData): Observable<Purchase> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales_orders/get_sales_order_copy', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateSalesOrder(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales_orders/update_sales_order', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  convertToSales(res): Observable<any> {
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/sales_orders/convert_to_sale', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getOrderSaleRefNo(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_orders/get_order_sales_ref', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getCreditNoteRefNo(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/creditNote/get_cr_note_refNo', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getDebitNoteRefNo(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/debitNote/get_dr_note_refNo', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesDebitNoteRefNo(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/debitNote/get_sdr_note_refNo', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getMeasure(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_orders/get_measurement', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesOrderInvPreview(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_orders/get_sales_order_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  posCancelSalesOrder(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_orders/pos_cancel_sales_order', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getSalesOrderSub(res: FormData): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_orders/get_sales_order_sub', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesOrderSubMeasurements(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_orders/get_sales_order_sub_measuremets', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getSalesOrderList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_orders/list_sales_order?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  // getSalesOredrPreview(res: FormData): Observable<Godown> {
  //   return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_orders/get_inv_preview', res, {
  //     headers: new HttpHeaders({
  //       'Access-Control-Allow-Origin': '*',
  //       Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
  //       cmptoken: localStorage.getItem('cmptoken')
  //     })
  //   }).pipe(catchError((error) => this.checkServerError(error)));
  // }

  getSalesOrderDetails(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_orders/get_sale_order_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getSalesOrderDetailsAll(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_orders/get_sale_order_all_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalesOrderDetailsPos(res: FormData): Observable<Godown> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/sales_orders/get_sale_order_details_pos', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  salesQuotationSummary(res: FormData, pageno: number): Observable<Sales> {
    return this.httpClient.post<Sales>(this.PHP_API_SERVER + '/api/sales_report/sales_quotation_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
getWarrantyStockList(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/stock/list_warranty_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
 addtoWarrantyStock(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/add_warranty_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidWarrantyStock(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/void_warranty_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidChallan(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/void_challan', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidQuotation(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/void_quotation', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidSalesOrder(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/void_sales_order', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  voidGoodsReceipt(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/goods_receipts/void_goods_receipt', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchDeliverychellan(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/search_delivery_chellan', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  rate_history(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales/rate_history', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  godownRepPeriod(res: FormData, pageno: number): Observable<Repprddet> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/godown_report/by_period?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getAllDelChallanDet(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/sales/get_all_del_challan_details', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  warrantyStockSummaryReport(res: any,pageno: number): Observable<any> {
    return this.httpClient.post<Godown>(this.PHP_API_SERVER + '/api/stock_report/warranty_stock_summary?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllOffer(curPage, perPage, data= {}): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/list?page=' + curPage + '&per_page=' + perPage, data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllOfferData(res: FormData): Observable<any> {
    if(res.get('date')){
      res.set('date', this.formatDate(res.get('date')));
    }
    return this.httpClient.post<Stockedit>(this.PHP_API_SERVER + '/api/offer/get_offer_data', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createOffer(data): Observable<any> {
    let sdate= this.formatDate(data.sdate);
    data.sdate = sdate + ' ' + this.formatTime(data.sdate);
    let edate= this.formatDate(data.edate);
    data.edate = edate + ' ' + this.formatTime(data.edate);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  giftVoucher(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/gift_voucher', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  empGiftVoucher(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/emp_gift_voucher', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  empGiftVoucherByID(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/emp_gift_voucher_by_id', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   listGiftVoucher(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/list_gift_vouchers', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidGiftVoucher(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/void_gift_voucher', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voucherLedgerUpdate(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/gift_voucher_ledger_update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  listEmplyeeVoucher(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/list_employee_vouchers', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  voidEmplyeeGiftVoucher(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/void_emplyee_gift_voucher', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  offerFlyerPosterCreation(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/offer_flyerPoster_creation', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }            
  deleteOfferFlyerPoster(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/delete_offer_flyerPoster', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  GetofferFlyerPosterList(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/get_offer_flyerPoster', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  voidOffer(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/void', data,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getPrdName(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/get_branch_rates', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  editrate(values): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/update_multiple_branch_rate', values, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  getSingleOffer(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/view', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateOffer(data): Observable<any> {
    let sdate= this.formatDate(data.sdate);
    data.sdate = sdate + ' ' + this.formatTime(data.sdate);
    let edate= this.formatDate(data.edate);
    data.edate = edate + ' ' + this.formatTime(data.edate);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/update', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  branchStock(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<Repprddet>(this.PHP_API_SERVER + '/api/product_report/branch_stock?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  exportAllProducts(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/export_all_products?page='+ pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  exportAllProductsNew(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/export_all_products_new?page='+ pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  updateRate(res: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/update_rate', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  quickSearch(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/quick_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getProdByStock(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/get_prod_by_stock', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  quicPurchkSearch(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/purchase_quick_search', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  quicPurchkSearchBrcd(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/purchase_quick_search_with_brcd', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  exportAllProductsSaleRate(res: FormData,pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/export_all_products_sale_rate?page='+ pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllOpeningStockList(res: FormData, pageno: number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/list_all_opening_stock?page=' + pageno, res,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


getpricelist(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/product/get_price_list', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateGeneralSetting(data: FormData) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/update_general_setting', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
 
  getGeneralSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/get_general_setting',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  pendingVanReqCount(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/van/get_pending_van_transfer_req',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  pendingStockTranReqCount(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock_transfer_request/get_pending_stock_branch_transfer_request',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }

  dbclearance(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/db_clearance', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
   copyBranch(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/sales_setting/copy_branch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
     getPrdStockInGd(res): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/stock/get_prd_stock_in_gd',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    });
  }


  
  selectCustProductwiseOffer(res,pageno:number): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/get_custmr_prdwise_offer?page=' + pageno, res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  addCustProdwiseOffer(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/offer/add_custmr_prdwise_offer', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  private checkServerError(error) {
    if(error.error.message == "User LoggedOut From Other Device, Please Relogin"){
      if(!localStorage.getItem("isBquickReloading") || localStorage.getItem("isBquickReloading") != '1'){
        localStorage.setItem("isBquickReloading", '1');
        alert("User LoggedOut From Other Device, Please Relogin");
        this.router.navigate(['/logout']);
      } 
    }
    return throwError(() => new Error('Something went wrong; please try again later.'));
  }

 

  checkGodownTransBatch(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/godown_transfer/check_batch', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  godownTransferApprove(searchval): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/godown_transfer/approve', searchval, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importReconciliationExcelSave(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconciliation/import' , res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }

  importReconciliationExcel(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconciliation-import' , res,{headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
      cmptoken: localStorage.getItem('cmptoken'),
    }) }).pipe(catchError((error) => this.checkServerError(error)));
  }

  

  getBankTransactions(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconciliation/transactions', null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  
  
  deleteReconciliation(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconciliation/delete', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getReconcileData(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/reconciliation_data' ,res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getCardData(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/card_data' ,res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getUncategorizedSystemBalance(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/uncategorized_system_balance' ,res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getReconcileBankEntries(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/reconciliation_bank_entries' ,res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getReconcileSystemEntries(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/reconciliation_system_entries' ,res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  reconciliationMatching(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/reconciliation_matching' ,res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  excludedTransaction(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/excluded_transaction' ,res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  excludedTransactionView(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/excluded_transaction_view',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  revertExcludedTransaction(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/excluded_transaction_revert',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  viewBankTransactions(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/bank_transactions_view',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  viewSystemTransactions(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/system_transactions_view',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  viewCategorizedTransactions(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/categorized_transactions_view',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  unlinkAllCategorized(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/unlink_all_categorized',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  unLinkCategorised(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/unlink_categorized',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  createRepacking(data): Observable<any> {
    // data.rec_date = this.formatDate(data.rec_date);
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/repacking/add', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  applyFilterSubmit(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reconcile/apply_filter_submit',res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllJobStatuses(res: any = ''): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/get_all_statuses', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getJobServiceType(res: any = ''): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/get_service_type', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  deleteJobOrder(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/delete', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getAllJobOrders(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/job_order/get_all_job_order', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  generateLoginToken(): Observable<User[]> {
    return this.httpClient.get<User[]>(this.PHP_API_SERVER + '/api/get_branch_token', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getGoodsRecDraft(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/goods_receipts/list_goods_receipt_draft', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  getGoodsRecDraftData(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/goods_receipts/temp_draft_preview', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  removeFromGdRecDraft(res: any): Observable<any> {
    return this.httpClient.post<Purchase>(this.PHP_API_SERVER + '/api/goods_receipts/remove_draft', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }


  // MainGroup
  createMainGroup(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/main_group/create_main_group', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateMainGroup(data): Observable<any> {
    return this.httpClient.post<any>(
      this.PHP_API_SERVER + '/api/main_group/update_main_group',
      data,{ 
      headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })}
    ).pipe(catchError((error) => this.checkServerError(error)));
  }

  readMainGroup(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/main_group/read_main_group', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
 
  deleteMainGroup(id): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/main_group/delete_main_group',
    { mg_id: id }, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getMobileSettings(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/mobile_settings/get_mobile_settings',null, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateMobileSettings(data) {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/mobile_settings/update_mobile_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
    
  searchMainGroup(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/main_group/search_main_group', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  interTransferDetailReport(formdata: any, pageno: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/reports/inter_transfer_detail?page=' + pageno, formdata,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

   getFreightTypes(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/freight_type/get_frieght_types',{}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  extTransferDetailReport(formdata: any, pageno: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ext_report/ext_transfer_detail?page=' + pageno, formdata,{
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  getExtStockReturnNextId(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/ext-stock-return/next_return_id', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchExtTransferForReturn(refNo): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/ext-stock-return/search_transfer?ref_no=' + refNo, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  saveExtStockReturn(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ext-stock-return/store', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listExtStockReturn(searchval, page): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ext-stock-return/list?page=' + page, searchval, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getExtStockReturnPreview(refNo): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/ext-stock-return/preview?ref_no=' + refNo, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  extStockReturnVoidList(searchval, pageNo): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ext-stock-return/list_void?page=' + pageNo, searchval, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  extStockReturnVoid(searchval): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/ext-stock-return/void', searchval, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getInterStockReturnNextId(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/inter-stock-return/next_return_id', {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  searchInterTransferForReturn(refNo): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/inter-stock-return/search_transfer?ref_no=' + refNo, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  saveInterStockReturn(data): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/inter-stock-return/store', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  listInterStockReturn(searchval, page): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/inter-stock-return/list?page=' + page, searchval, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getInterStockReturnPreview(refNo): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/inter-stock-return/preview?ref_no=' + refNo, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  // HR
  getErpModuleStatus(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/settings/get_module_status', data, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  AdvanceList(page, perPage): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/employee-advance/list', {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        }),
        params: {
          page: page.toString(),
          per_page: perPage.toString()
        }
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
  }

  AdvanceCount(params?: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/employee-advance/count', {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        }),
        params: params
      }
    );
  }

  AdvanceStatusChange(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/employee-advance/status_change', data, {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
  }
   
  getHrMenuByGroup(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/menu/get_hr_menu_by_group', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
  
  hrUpdatePrivilage(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/hr_privilage/hr_update_privilage', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
    
  getHrUserPrivilage(res: FormData): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/hr_privilage/get_hr_user_privilages', res, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getHrSettings(params?: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/settings/get_hr_settings', {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        }),
        params: params
      }
    );
  }

  updateHrSettings(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/settings/update_hr_settings', data, {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalaryPaymentList(page, perPage): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/salary-payment/list_salary_payment', {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        }),
        params: {
          page: page.toString(),
          per_page: perPage.toString()
        }
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
  }
    
  getSalaryLedger(sp_type: number): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/salary-payment/get_salary_ledger?sp_type=' + sp_type, {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }
    );
  }

  checkErpNextSalaryRequest(params?: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/salary-payment/check-erpnext-salary-request', {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        }),
        params: params
      }
    );
  }

  updateErpNextSalaryStatus(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/salary-payment/update-erpnext-salary-status', data, {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
          cmptoken: localStorage.getItem('cmptoken')
        })
      }
    ).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateSalaryPaymentStatus(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/salary-payment/update-salary-payment-status', data, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getSalaryRequestCount(params?: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/salary-payment/get_salary_request_count', {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      }),
        params: params
    });
  }

  deleteErpSalaryJournal(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/salary-payment/delete-erp-salary-journal', data, {
      headers: new HttpHeaders({          
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  getHrIntegrationStatus(): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/hr-integration/get-integration-status', {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      }),
    });
  }

  createErpNextSite(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/hr-integration/create-erpnext-site', data, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  checkSiteCreationStatus(branchId?: any): Observable<any> {
    return this.httpClient.get<any>(this.PHP_API_SERVER + '/api/hr-integration/check-site-creation-status', {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      }),
      params: {
        branch_id: branchId != null ? branchId.toString() : ''
      }
    });
  }

  // production settings
  getProductionSetting(): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/production_settings/get_production_setting', {}, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }

  updateProductionSettings(data: any): Observable<any> {
    return this.httpClient.post<any>(this.PHP_API_SERVER + '/api/production_settings/update_production_settings', data, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        Authorization: 'Bearer ' + localStorage.getItem("auth_token"),
        cmptoken: localStorage.getItem('cmptoken')
      })
    }).pipe(catchError((error) => this.checkServerError(error)));
  }
}